import React, { FC } from "react";

/**
 * @author
 * @function @HideViewGraphicSvg
 **/

const HideViewGraphicSvg: FC = () => {
    return (
        <svg
            width="52"
            height="32"
            viewBox="0 0 52 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="51"
                height="31"
                rx="15.5"
                fill="#C4CCD5"
            />
            <path
                d="M33.5 17.6667H32.6666V8.49999C32.6666 8.27898 32.5788 8.06701 32.4225 7.91073C32.2663 7.75445 32.0543 7.66666 31.8333 7.66666H20.1666C19.9456 7.66666 19.7337 7.75445 19.5774 7.91073C19.4211 8.06701 19.3333 8.27898 19.3333 8.49999V17.6667H18.5C18.2789 17.6667 18.067 17.7545 17.9107 17.9107C17.7544 18.067 17.6666 18.279 17.6666 18.5C17.6666 18.721 17.7544 18.933 17.9107 19.0892C18.067 19.2455 18.2789 19.3333 18.5 19.3333H25.1666V20.2917L21.375 22.7917C21.2194 22.8879 21.0999 23.0328 21.0348 23.2037C20.9697 23.3747 20.9627 23.5623 21.0148 23.7377C21.0669 23.9131 21.1753 24.0664 21.3232 24.174C21.4712 24.2817 21.6504 24.3377 21.8333 24.3333C21.9971 24.3352 22.1574 24.2857 22.2916 24.1917L25.1666 22.2917V23.5C25.1666 23.721 25.2544 23.933 25.4107 24.0892C25.567 24.2455 25.7789 24.3333 26 24.3333C26.221 24.3333 26.4329 24.2455 26.5892 24.0892C26.7455 23.933 26.8333 23.721 26.8333 23.5V22.2917L29.7083 24.1917C29.8425 24.2857 30.0028 24.3352 30.1666 24.3333C30.3447 24.3319 30.5176 24.2736 30.66 24.1668C30.8025 24.06 30.907 23.9104 30.9583 23.7399C31.0095 23.5694 31.0048 23.3869 30.9448 23.2193C30.8848 23.0516 30.7727 22.9076 30.625 22.8083L26.8333 20.3083V19.3333H33.5C33.721 19.3333 33.9329 19.2455 34.0892 19.0892C34.2455 18.933 34.3333 18.721 34.3333 18.5C34.3333 18.279 34.2455 18.067 34.0892 17.9107C33.9329 17.7545 33.721 17.6667 33.5 17.6667ZM31 17.6667H21V9.33332H31V17.6667ZM23.5 16C23.6372 15.9993 23.7722 15.9647 23.8928 15.8993C24.0135 15.8338 24.1161 15.7396 24.1916 15.625L25.3 13.9583L26.2416 14.9083C26.3291 14.9963 26.435 15.0636 26.5518 15.1055C26.6686 15.1473 26.7932 15.1625 26.9166 15.15C27.0395 15.1365 27.1578 15.0959 27.263 15.031C27.3682 14.9662 27.4577 14.8787 27.525 14.775L29.1916 12.275C29.2898 12.092 29.3161 11.879 29.2654 11.6776C29.2147 11.4763 29.0907 11.3011 28.9176 11.1864C28.7445 11.0717 28.5348 11.0258 28.3297 11.0576C28.1245 11.0894 27.9385 11.1966 27.8083 11.3583L26.7 13.025L25.7583 12.075C25.6709 11.987 25.5649 11.9197 25.4481 11.8779C25.3313 11.836 25.2067 11.8208 25.0833 11.8333C24.9604 11.8468 24.8421 11.8874 24.7369 11.9523C24.6317 12.0172 24.5422 12.1046 24.475 12.2083L22.8083 14.7083C22.6877 14.892 22.6445 15.116 22.6882 15.3314C22.7319 15.5467 22.8589 15.7361 23.0416 15.8583C23.1758 15.9523 23.3361 16.0019 23.5 16Z"
                fill="#74788D"
            />
            <rect
                x="0.5"
                y="0.5"
                width="51"
                height="31"
                rx="15.5"
                stroke="#C4CCD5"
            />
        </svg>
    );
};

export default HideViewGraphicSvg;
